export default __webpack_public_path__ + "static/media/Christian.a56f8728.mov";